import { getScanPhotoImageUrl } from '@kaiizen/kai-pro-api';
import { ORIGINAL_SIZE, PhotoSize } from '../contexts';
import { PreWarmItem } from '../contexts/PreWarmCache';
import { getCacheFileName } from './GalleryPhotoLoader';

/**
 * Build the `{ fileName, url }` pre-warm batch for a set of scan photos.
 *
 *   - `fileName` uses the shared cache-key convention ({@link getCacheFileName}),
 *     so these entries are the same ones the gallery reads/writes.
 *   - `url` is the scan-photo-data endpoint, prefixed with `apiUrl` — empty on
 *     web (relative = current origin), explicit base on native.
 *
 * Pure: no gallery, no FileCache — just the photo → (key, url) mapping.
 */
export const buildScanPhotoPreWarmItems = (
  apiUrl: string | undefined,
  photoIds: string[],
  size: PhotoSize = ORIGINAL_SIZE,
): PreWarmItem[] =>
  photoIds.map(photoId => ({
    fileName: getCacheFileName(photoId, size),
    url: `${apiUrl ?? ''}${getScanPhotoImageUrl(photoId, size === ORIGINAL_SIZE ? undefined : { maxDimension: size })}`,
  }));
